import React, { PureComponent } from "react";
import { auth } from "helpers/Firebase";
import Button from "antd/lib/button";
import Input from "antd/lib/input";

import "./style.css";

class Login extends PureComponent {
  state = {
    email: "",
    password: "",
    isLoading: false
  };

  login = () => {
    const { email, password } = this.state;
    this.setState({ isLoading: true });
    auth.signInWithEmailAndPassword(email, password).catch(err => {
      console.log(err);
      this.setState({ isLoading: false });
    });
  };

  render() {
    const { email, password, isLoading } = this.state;
    return (
      <div className="Login">
        <div className="Login__box">
          <h1>Login</h1>
          <Input
            value={email}
            placeholder="Email"
            onChange={e => this.setState({ email: e.target.value })}
          />
          <div />
          <Input
            value={password}
            placeholder="Password"
            type="password"
            onChange={e => this.setState({ password: e.target.value })}
          />
          <div />
          <Button
            type="primary"
            size="large"
            onClick={this.login}
            block
            loading={isLoading}
          >
            LOGIN
          </Button>
        </div>
      </div>
    );
  }
}

export default Login;



// WEBPACK FOOTER //
// ./src/containers/Login/index.js